import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StateStatus } from '@guryou/redux';

import { getPlans } from '../new';

const usePlans = () => {
  const dispatch = useDispatch();
  const { data, status, version, entity } = useSelector(state => state.plans.all);

  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED) {
      dispatch(getPlans());
    }
  }, [data, dispatch, status]);

  return { data: data || [], status, version, entity };
};

export default usePlans;
